var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaveShareMixLinkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106.09 106.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#444a7f;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_18",
    "data-name": "Layer 18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 106.09,
    height: 106.09,
    rx: 53.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.86,66.24,47.13,74A10.2,10.2,0,0,1,32.71,59.55l7.73-7.73a3.24,3.24,0,0,0-4.58-4.59L28.13,55a16.68,16.68,0,1,0,23.59,23.6l7.73-7.74a3.24,3.24,0,0,0-4.59-4.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78,28.72a16.69,16.69,0,0,0-23.59,0l-7.73,7.73A3.24,3.24,0,0,0,51.22,41L59,33.3A10.2,10.2,0,0,1,73.38,47.73l-7.73,7.73A3.24,3.24,0,1,0,70.23,60L78,52.31A16.69,16.69,0,0,0,78,28.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.94,68.74a3.25,3.25,0,0,0,4.58,0L68.15,43.12a3.25,3.25,0,0,0-4.59-4.59L37.94,64.16A3.25,3.25,0,0,0,37.94,68.74Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveShareMixLinkIcon);
export default __webpack_public_path__ + "static/media/SaveShareMixLinkIcon.4ce42c3410024c402e818c54d1490656.svg";
export { ForwardRef as ReactComponent };